<div class="table-container">
  <!-- Loading Spinner -->
  <div class="loader" *ngIf="isLoading">
    <mat-progress-spinner mode="indeterminate" diameter="100" color="accent"></mat-progress-spinner>
    <h1>Loading...</h1>
  </div>

  <!-- No Data Message -->
  <div class="inner-table" *ngIf="trackingMyViewsData?.length === 0 && !isLoading">
    No data found.
  </div>
  <div class="table-data">
    <table
      #outerTable
      mat-table
      #outerSort="matSort"
      [dataSource]="dataSource"
      multiTemplateDataRows
      class="outer-table mat-elevation-z8"
      matSort
      *ngIf="trackingMyViewsData?.length > 0 && !isLoading"
    >
      <!-- Dynamic Outer Columns -->
      <ng-container
        *ngFor="let column of columnDefs"
        [matColumnDef]="column.id"
        [sticky]="pinnedColumns.has(column.id)"
      >
        <th
          mat-header-cell
          *matHeaderCellDef
          [mat-sort-header]="isSortable(column.id) ? column.id : null"
          [disabled]="!isSortable(column.id)"
          [ngStyle]="getCellStyle(column)"
          [class.pinned-header]="pinnedColumns.has(column.id)"
        >
          <div class="header-with-pin">
            <span
              *ngIf="pinEnabledColumns?.includes(column.id)"
              class="pin-btn"
              (click)="togglePin(column.id, $event)"
              matTooltip="{{ pinnedColumns.has(column.id) ? 'Unpin' : 'Pin' }}"
            >
              <mat-icon>
                {{ pinnedColumns.has(column.id) ? "push_pin" : "push_pin_outlined" }}
              </mat-icon>
            </span>
            <span>{{ column.label }}</span>
          </div>
        </th>
        <td
          mat-cell
          *matCellDef="let element"
          class="cell-with-menu"
          [ngStyle]="getCellStyle(column)"
        >
          <ng-container [ngSwitch]="column.valueType">
            <!--   Multi Select Dropdown -->
            <mat-form-field
              *ngSwitchCase="'multiselect'"
              appearance="outline"
              class="cell-dropdown"
              floatLabel="never"
            >
              <mat-select
                #ms="matSelect"
                [value]="element[column.id]?.value"
                multiple
                matTooltipPosition="above"
                matTooltipShowDelay="300"
                (openedChange)="onDropdownOpened($event, ms, column, element)"
                (closed)="onDropdownOpened(false, ms, column, element)"
                (selectionChange)="onMultiCellDropdownChange(element, column, $event.value)"
                [disabled]="!canEdit()"
              >
                <mat-option
                  *ngFor="
                    let ref of filteredOptions[column.id + '_' + element.opportunityId] ||
                      getSortedReferences(column, element)
                  "
                  [value]="ref.value"
                >
                  {{ ref.viewValue }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <!--  Single Select Dropdown -->
            <div class="relative w-full">
              <mat-form-field
                *ngSwitchCase="'dropdown'"
                appearance="outline"
                class="cell-dropdown"
                [ngClass]="{
                  'wide-dropdown': [
                    'quote',
                    'signings',
                    'FOTS',
                    'finalContract',
                    'submission',
                  ].includes(column.id),
                  'completed-dropdown': isColumnComplete(column.id, element),
                }"
                floatLabel="never"
              >
                <mat-select
                  [(ngModel)]="element[column.id].value"
                  (ngModelChange)="onCellDropdownChange(element, column, $event)"
                  [matTooltip]="element[column.id]?.value || ''"
                  matTooltipPosition="above"
                  matTooltipShowDelay="300"
                  [disabled]="!canEdit()"
                >
                  <mat-option *ngFor="let ref of column.references" [value]="ref.value">
                    <div class="option-item">
                      <span class="option-text">
                        {{ ref.viewValue }}
                        <span *ngIf="ref.date" class="option-picked-date">
                          — {{ ref.date | date: "dd-MMM-yyyy" }}
                        </span>
                      </span>

                      <!-- Inline SVG calendar icon -->
                      <button
                        *ngIf="ref.value && ref.value.trim() !== '' && ref.value.trim() !== 'N/A'"
                        mat-icon-button
                        class="custom-calendar-button"
                        type="button"
                        (click)="
                          $event.stopPropagation();
                          openCalendarOverlay($event, ref, column, element)
                        "
                        aria-label="Pick date"
                        [class.has-date]="
                          element[column.id]?.dateMap?.active?.[ref.value.toLowerCase()] ||
                          element[column.id]?.dateMap?.history?.[ref.value.toLowerCase()]
                        "
                      >
                        <svg
                          class="calendar-icon"
                          xmlns="http://www.w3.org/2000/svg"
                          height="25"
                          width="25"
                        >
                          <path
                            d="M19 4h-1V2h-2v2H8V2H6v2H5
       c-1.11 0-1.99.9-1.99 2L3 20
       c0 1.1.89 2 2 2h14c1.1 0 2-.9
       2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z
       M7 11h5v5H7z"
                          />
                        </svg>
                      </button>
                    </div>
                  </mat-option>
                </mat-select>

                <!-- Comment button -->
                <button
                  mat-icon-button
                  matSuffix
                  aria-label="Add comment"
                  (click)="$event.stopPropagation(); openCommentDialog(element, column)"
                  [class.has-comment]="element[column.id]?.comments?.length > 0"
                >
                  <mat-icon>comment</mat-icon>
                </button>
              </mat-form-field>
            </div>
            <!--   Numeric -->
            <ng-container *ngSwitchCase="'numeric'">
              <ng-container
                *ngIf="
                  element[column.id]?.value !== null && element[column.id]?.value !== undefined;
                  else showNA
                "
              >
                <app-progress-cell [value]="element[column.id]?.value"></app-progress-cell>
              </ng-container>
              <ng-template #showNA><span>N/A</span></ng-template>
            </ng-container>

            <!--   Complete Column -->
            <ng-container *ngIf="column.id === 'complete'">
              <mat-icon class="icon" (click)="downloadComments(element); $event.stopPropagation()">
                cloud_download
              </mat-icon>
            </ng-container>
            <span *ngSwitchDefault>
              {{ element[column.id]?.value }}
            </span>
          </ng-container>
        </td>
      </ng-container>

      <!-- Expanded Detail Row -->
      <ng-container matColumnDef="expandedDetail">
        <td mat-cell *matCellDef="let element" [attr.colspan]="columnDefs.length">
          <div
            class="tracking-element-detail"
            [@detailExpand]="element === expandedElement ? 'expanded' : 'collapsed'"
          >
            <div
              class="inner-table mat-elevation-z8"
              *ngIf="element.details?.length && expandedElement"
            >
              <div *ngFor="let detailsData of element.details">
                <mat-form-field>
                  <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter" />
                  <span class="structure-name">{{ detailsData.structureName }}</span>
                </mat-form-field>
              </div>
            </div>
          </div>
        </td>
      </ng-container>

      <!-- Outer Table Rows -->
      <tr mat-header-row *matHeaderRowDef="colIds; sticky: true"></tr>
      <tr
        mat-row
        *matRowDef="let element; columns: colIds"
        class="outer-row"
        [class.tracking-expanded-row]="expandedElement === element"
        [class.complete-class]="element.complete?.value === 'Yes'"
        (click)="toggleRow(element)"
      ></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: ['expandedDetail']"
        class="tracking-details-row"
      ></tr>
    </table>
  </div>
  <ng-template #calendarTemplate let-data>
    <div class="calendar-overlay-panel" (click)="$event.stopPropagation()">
      <mat-calendar
        [startAt]="data.selectedDate"
        [selected]="null"
        [dateClass]="data.dateClass"
        (selectedChange)="data.onDateSelected($event)"
      ></mat-calendar>
    </div>
  </ng-template>

  <div class="table-footer">
    <mat-paginator
      #paginator
      [pageSize]="10"
      [pageSizeOptions]="[5, 10, 25, 50]"
      showFirstLastButtons
    ></mat-paginator>
  </div>
</div>
